import { render } from "./App.vue?vue&type=template&id=aa07fb4e"
const script = {}
script.render = render

export default script